import axios from 'axios';

export const extractErrorMessage = (
  error: unknown,
  fallback: string
): string => {
  if (axios.isAxiosError(error)) {
    const data: unknown = error.response?.data;
    if (typeof data === 'string' && data.trim().length > 0) return data;
    if (data && typeof data === 'object') {
      const candidate = data as Record<string, unknown>;
      const keys = ['message', 'title', 'detail', 'error'];
      for (const key of keys) {
        const value = candidate[key];
        if (typeof value === 'string' && value.trim().length > 0) return value;
      }
      const errors = candidate.errors;
      if (Array.isArray(errors) && errors.length > 0) {
        const first = errors[0];
        if (typeof first === 'string') return first;
        if (first && typeof first === 'object') {
          const fmsg = (first as { message?: unknown }).message;
          if (typeof fmsg === 'string' && fmsg.trim().length > 0) return fmsg;
        }
      }
      if (errors && typeof errors === 'object') {
        const firstArr = Object.values(errors)[0];
        if (Array.isArray(firstArr) && typeof firstArr[0] === 'string') {
          return firstArr[0] as string;
        }
      }
    }
    if (error.message && error.message.trim().length > 0) return error.message;
  }
  if (error instanceof Error && error.message.trim().length > 0) {
    return error.message;
  }
  return fallback;
};
